import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import FlowHistoryFieldLabel from './FlowHistoryFieldLabel';

const FlowHistoryFieldLabelBridge = react2angular(FlowHistoryFieldLabel, [
  'fieldType',
  'fieldValue',
  'validationJson'
]);

export default FlowHistoryFieldLabelBridge;
